import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';
import {OutlineChapterUnitBasicModel} from '@core/modules/rest/consent/response/outline-chapter-unit-basic.model';
import {getLanguageEnumByLanguageCode, LanguageEnum} from '@core/enums/language.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-display-consent-outline',
    templateUrl: './display-consent-outline.component.html',
    styleUrls: ['./display-consent-outline.component.scss']
})

export class DisplayConsentOutlineComponent implements OnInit, OnChanges {
    @Input() treeData: OutlineChapterUnitBasicModel[] | undefined;
    @Input() currentUnitOrderId: number | undefined;
    @Input() listClickable = false;
    @Input() comments: CommentBasicModel[] | undefined;
    @Input() scrollIntoViewFeature: boolean;
    @Output() emitClickedElement = new EventEmitter<OutlineUnitBasicModel>();
    @Output() emitUnderstoodItemClickedEvent = new EventEmitter<number>();

    clickedToPreview: boolean;
    appLanguage: string;
    noTitle: string;

    constructor(private translate: TranslateService) {}

    ngOnInit(): void {
        const languageEnum = getLanguageEnumByLanguageCode(localStorage.getItem('languageCode'));
        if (languageEnum === LanguageEnum.GERMAN) {
            this.appLanguage = this.translate.instant('GENERAL.GERMAN');
        } else if (languageEnum === LanguageEnum.SERBIAN) {
            this.appLanguage = this.translate.instant('GENERAL.SERBIAN');
        } else {
            this.appLanguage = this.translate.instant('GENERAL.ENGLISH');
        }
        this.noTitle = this.translate.instant('GENERAL.UNTITLED') + '*';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.currentUnitOrderId && this.currentUnitOrderId) {
            if (this.scrollIntoViewFeature && !this.clickedToPreview) {
                this.scrollIntoView();
            }
            this.clickedToPreview = false;
        }
    }

    elementClicked(unit: OutlineUnitBasicModel): void {
        if (this.listClickable) {
            this.emitClickedElement.emit(unit);
        } else if (unit.status === 'UNDERSTOOD') {
            this.clickedToPreview = true;
            this.emitUnderstoodItemClickedEvent.emit(unit.unitOrder);
        }
    }

    stripTagsFromString(text: string): string {
        if (text === null) {
            return '';
        } else {
            return text.replace(/(<([^>]+)>)/gi, '');
        }
    }

    markUnitIfItHasComments(informationUnitTitle: string): boolean {
        if (this.comments) {
            const index = this.comments?.findIndex(item => item.informationUnitTitle === informationUnitTitle);
            return index > -1;
        }
        return false;
    }

    private scrollIntoView(): void {
        const currentUnit = document.getElementById(this.currentUnitOrderId.toString());
        if (currentUnit != null) {
            currentUnit.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center'
            });
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }

    onKeyUp(event: KeyboardEvent, item: OutlineUnitBasicModel): void {
        if (event.key === 'Enter') {
            this.elementClicked(item);
        } else if (event.code === 'Space') {
            event.preventDefault();
        } else if (event.key === 'Tab') {
            this.focusNextItem();
        }
    }

    focusNextItem(): void {
        const focusable = document.querySelectorAll('p.cursorPointer');
        focusable.forEach(item => {
            item.setAttribute('tabIndex', '0');
        });
    }
}
